export default function ReportIcon24({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.0000 3.0000V19.0001C3.0000 19.5305 3.2107 20.0391 3.5858 20.4143C3.9609 20.7893 4.4696 21.0000 5.0000 21.0000H21.0000M7.0000 16.0001C7.5000 14.0000 8.5000 9.0000 11.0000 9.0000C13.0000 9.0000 13.0000 12.0000 15.0000 12.0000C17.5001 12.0000 19.5000 7.0000 19.9999 5.0000"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
